import { intensity, totalsByDay } from './planUsageHeatmapBands.js'

const WEEKS = 53
const DAYS = WEEKS * 7
const MS_PER_DAY = 86_400_000

function dayKey(date) {
  return date.toISOString().slice(0, 10)
}

/**
 * Map a daily usage series onto the heatmap's 53x7 grid, ending today.
 *
 * @param {{ bucket: string, total_tokens: number }[]} [series]
 */
export function buildHeatColumnsFromUsage(series) {
  const totals = totalsByDay(series)
  const peak = Math.max(1, ...totals.values())
  const end = new Date()
  end.setUTCHours(0, 0, 0, 0)
  const start = new Date(end.getTime() - (DAYS - 1) * MS_PER_DAY)

  const columns = []
  for (let week = 0; week < WEEKS; week += 1) {
    const column = []
    for (let day = 0; day < 7; day += 1) {
      const at = new Date(start.getTime() + (week * 7 + day) * MS_PER_DAY)
      column.push(intensity(totals.get(dayKey(at)) ?? 0, peak))
    }
    columns.push(column)
  }
  return columns
}
